import { Link } from 'react-router-dom'
import styledComponents from 'styled-components'

export default styledComponents(Link)`
  color: inherit;
  text-decoration: none;
`



// WEBPACK FOOTER //
// ./src/components/views/buttons/Link.js